import { Divider, FormControl } from "@mui/material";
import { motion } from "framer-motion";
import { memo, useCallback } from "react";
import Select from "react-select";
import CustomButtonV2 from "../../../../../components/CustomButtonV2/CustomButtonV2.js";
import NewIcon from "../../../../../components/NewIcon/NewIcon.js";
import SelectEmbarqueV2 from "../../../../../components/SelectEmbarqueV2/SelectEmbarqueV2.js";
import { ClipboardSemAutorizacaoMessage } from "../../../../../contexts/FiltroContext.tsx";
import { useToast } from "../../../../../contexts/ToastContext.tsx";
import Separator from "../../../../../core/components/Separator.tsx";
import MultiImageCarousel from "../../../../../core/data-display/MultiImageCarousel.tsx";
import CadastroViagemSectionTitle from "../../components/CadastroViagemSectionTitle.tsx";

function FormEmbarqueBottom({
    setIdAtual,
    setDisable,
    contextoEmbarque,
    setValues,
    values,
    setValuesSelect,
    setValidator,
    valuesSelect,
    estiloFrota,
    selectMessage,
    props,
    setOpenCadastroEmbalagem,
    embalagem,
    mercadoria,
    labelMercadoria,
    setOpenCadastroMercadoria,
    usuarioGerens,
    setOpenCadastroMeioPagamento,
    meioPagamento,
    setVerificaMotivo,
    setOpenCadastroMotivo,
    verificaMotivo,
    motivo,
    loadingCadastro,
    editarTemplate,
    editar,
    cadastrarTemplate,
    cadastrar,
    validator,
    imagesFinalizacaoViagem,
    setIsOpenModalImage,
    setSelectedImage,
    handleDeleteImage,
    location,
    navigate
}) {
    const { showToast } = useToast();

    const handleClickCancelar = useCallback(() => {
        if (
            contextoEmbarque === "templateEmbarque" ||
            location.pathname.includes("/modelo-viagens")
        ) {
            navigate("/modelo-viagens");
            return;
        }
        navigate(-1);
    }, [contextoEmbarque, location.pathname, navigate]);

    const handleClearMotivo = useCallback(() => {
        setValuesSelect((current) => ({
            ...current,
            motivo: null,
        }));
        setValues((current) => ({
            ...current,
            motivo: null,
        }));
        setValues((current) => ({
            ...current,
            motivoId: null,
        }));
    }, [setValues, setValuesSelect]);

    const copyLinkFinalizarViagem = useCallback(() => {
        if (!document.hasFocus()) {
            console.warn("Documento não está em foco. Tentando focar...");
            window.focus();
        }

        navigator.permissions
            .query({ name: "clipboard-write" })
            .then((permissionStatus) => {
                if (permissionStatus.state === "denied") {
                    showToast(ClipboardSemAutorizacaoMessage(), "error");
                    return;
                }

                const baseUrl = window.location.origin;
                const idViagem = values.idEmbarque || values.id || "";

                if (!idViagem) {
                    showToast("ID da viagem não encontrado.", "error");
                    return;
                }

                const link = `${baseUrl}/viagem/finalizar-viagem/${idViagem}`;
                navigator.clipboard
                    .writeText(link)
                    .then(() => {
                        showToast("Link copiado para a área de transferência!", "success");
                    })
                    .catch(() => {
                        showToast("Erro ao copiar o link.", "error");
                    });
            })
            .catch((error) => {
                showToast("Erro ao verificar permissões de clipboard.", "error");
            });
    }, [values.idEmbarque, values.id, showToast]);

    const clearEmbalagem = () => {
        setValuesSelect((current) => ({ ...current, embalagem: "" }));
        setValues((current) => ({ ...current, embalagem: "", embalagemId: null }));
    };

    const clearMercadoria = () => {
        setValuesSelect((current) => ({ ...current, mercadoria: "" }));
        setValues((current) => ({ ...current, mercadoria: "" }));
        setValues((current) => ({ ...current, mercadoriaId: null }));
        setValidator((current) => ({ ...current, validatorMercadoria: "false" }));
    };

    const clearMeioPagamento = () => {
        setValuesSelect((current) => ({ ...current, meioPagamento: "" }));
        setValues((current) => ({
            ...current,
            meioPagamento: "",
            meioPagamentoId: null,
        }));
        setValidator((current) => ({
            ...current,
            validatorMeioPagamento: "false",
        }));
    };

    const clearMeioPagamento2 = () => {
        setValuesSelect((current) => ({ ...current, meioPagamento2: "" }));
        setValues((current) => ({
            ...current,
            meioPagamento2: "",
            meioPagamento2Id: null,
        }));
        setValidator((current) => ({
            ...current,
            validatorMeioPagamento2: "false",
        }));
    };

    return (
        <>
            <CadastroViagemSectionTitle title="Geral:" />
            <div className="container-select-emb">
                <div className="coluna-1-emb">
                    <div className="coluna-emb">
                        <div>
                            <p className="input-label-emb" htmlFor="descricao">
                                Embalagem:
                            </p>
                            <SelectEmbarqueV2
                                classeCss={225}
                                onChange={(e) => {
                                    setValuesSelect((current) => ({
                                        ...current,
                                        embalagem: e,
                                    }));
                                    setValues((current) => ({
                                        ...current,
                                        embalagem: e.value,
                                    }));
                                    setValues((current) => ({
                                        ...current,
                                        embalagemId: e.id,
                                    }));
                                }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setDisable(true);
                                    setOpenCadastroEmbalagem(true);
                                }}
                                clearSelection={clearEmbalagem}
                                onInfoIconClick={setIdAtual}
                                id="idEmbalagem"
                                pequeno={true}
                                value={valuesSelect.embalagem}
                                titulo="Embalagem"
                                dadosSelect={embalagem}
                                referenciaId="nome"
                                referenciaItem="nome"
                            />
                        </div>
                        <NewIcon
                            onClick={() => {
                                setOpenCadastroEmbalagem(true);
                                setIdAtual(null);
                                setDisable(false);
                            }}
                        />
                    </div>
                    <div className="coluna-emb">
                        <div>
                            <p className="input-label-emb" htmlFor="descricao">
                                Mercadoria:
                            </p>
                            <FormControl sx={{ width: "225px" }}>
                                <Select
                                    value={valuesSelect.mercadoria}
                                    options={mercadoria.map((data) => ({
                                        value: data.nome,
                                        label: data.nome,
                                    }))}
                                    styles={estiloFrota}
                                    placeholder="Digite para buscar."
                                    noOptionsMessage={({ inputValue }) =>
                                        selectMessage(inputValue)
                                    }
                                    formatOptionLabel={labelMercadoria}
                                    clearSelection={clearMercadoria}
                                    onChange={(e) => {
                                        const selectedOption = mercadoria.find(
                                            (option) => option.nome === e.value
                                        );
                                        setValuesSelect((current) => ({
                                            ...current,
                                            mercadoria: e,
                                        }));
                                        setValues((current) => ({
                                            ...current,
                                            mercadoria: selectedOption.nome,
                                            mercadoriaId: selectedOption.idMercadoria,
                                        }));
                                        setValidator((current) => ({
                                            ...current,
                                            validatorMercadoria: "true",
                                        }));
                                    }}
                                />
                            </FormControl>
                        </div>
                        <NewIcon
                            onClick={() => {
                                setOpenCadastroMercadoria(true);
                                setIdAtual(null);
                                setDisable(false);
                            }}
                        />
                    </div>
                    <div className="coluna-emb">
                        <div>
                            <p className="input-label-emb" htmlFor="descricao">
                                Load:
                            </p>
                            <input
                                type="text"
                                className="input-emb"
                                style={{ width: "170px" }}
                                onChange={(e) => {
                                    setValues((current) => ({
                                        ...current,
                                        load: e.target.value,
                                    }));
                                }}
                                value={values.load || ""}
                            />
                        </div>
                    </div>
                    <div className="coluna-emb">
                        <div>
                            <p className="input-label-emb" htmlFor="descricao">
                                Margem:
                            </p>
                            <input
                                type="text"
                                className="input-emb"
                                style={{ width: "170px" }}
                                disabled={true}
                                value={values.margem || ""}
                            />
                        </div>
                    </div>
                    <div className="coluna-emb">
                        <div>
                            <p className="input-label-emb" htmlFor="descricao">
                                Usuário Responsável:
                            </p>
                            <SelectEmbarqueV2
                                classeCss={175}
                                onChange={(e) => {
                                    setValuesSelect((current) => ({
                                        ...current,
                                        usuarioResponsavel: e,
                                    }));
                                    setValues((current) => ({
                                        ...current,
                                        usuarioResponsavel: e.value,
                                    }));
                                    setValues((current) => ({
                                        ...current,
                                        usuarioResponsavelId: e.id,
                                    }));
                                    setValidator((current) => ({
                                        ...current,
                                        validatorUsuarioResponsavel: "true",
                                    }));
                                }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setDisable(true);
                                    setOpenCadastroMercadoria(true);
                                }}
                                onInfoIconClick={setIdAtual}
                                pequeno={true}
                                id="idUsuario"
                                value={valuesSelect.usuarioResponsavel}
                                titulo="Usuario"
                                dadosSelect={usuarioGerens}
                                referenciaId="usuario"
                                referenciaItem="usuario"
                                info={false}
                            />
                        </div>
                    </div>
                </div>
                <CadastroViagemSectionTitle title="Dados Meio Pegamento:" />
                <div className="container-select-emb">
                    <div className="coluna-1-emb">
                        <div className="coluna-emb">
                            <div>
                                <p className="input-label-emb" htmlFor="descricao">
                                    Meio Pagamento:
                                </p>
                                <SelectEmbarqueV2
                                    classeCss={200}
                                    onChange={(e) => {
                                        setValuesSelect((current) => ({
                                            ...current,
                                            meioPagamento: e,
                                        }));
                                        setValues((current) => ({
                                            ...current,
                                            meioPagamento: e.value,
                                        }));
                                        setValues((current) => ({
                                            ...current,
                                            meioPagamentoId: e.id,
                                        }));
                                        setValidator((current) => ({
                                            ...current,
                                            validatorMeioPagamento: "true",
                                        }));
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setDisable(true);
                                        setOpenCadastroMeioPagamento(true);
                                    }}
                                    clearSelection={clearMeioPagamento}
                                    onInfoIconClick={setIdAtual}
                                    pequeno={true}
                                    id="idMeioPagamento"
                                    value={valuesSelect.meioPagamento}
                                    titulo="Meio de Pagamento"
                                    dadosSelect={meioPagamento}
                                    referenciaId="nome"
                                    referenciaItem="nome"
                                />
                            </div>
                            <NewIcon
                                onClick={() => {
                                    setOpenCadastroMeioPagamento(true);
                                    setIdAtual(null);
                                    setDisable(false);
                                }}
                            />
                        </div>
                        <div className="coluna-emb">
                            <div>
                                <p className="input-label-emb" htmlFor="descricao">
                                    Meio Pagamento 2:
                                </p>
                                <SelectEmbarqueV2
                                    classeCss={200}
                                    onChange={(e) => {
                                        setValuesSelect((current) => ({
                                            ...current,
                                            meioPagamento2: e,
                                        }));
                                        setValues((current) => ({
                                            ...current,
                                            meioPagamento2: e.value,
                                            meioPagamento2Id: e.id,
                                        }));
                                    }}
                                    clearSelection={clearMeioPagamento2}
                                    onInfoIconClick={setIdAtual}
                                    pequeno={true}
                                    id="idMeioPagamento"
                                    value={valuesSelect.meioPagamento2}
                                    titulo="Meio de Pagamento 2"
                                    dadosSelect={meioPagamento}
                                    referenciaId="nome"
                                    referenciaItem="nome"
                                />
                            </div>
                            <NewIcon
                                onClick={() => {
                                    setOpenCadastroMeioPagamento(true);
                                    setIdAtual(null);
                                    setDisable(false);
                                }}
                            />
                        </div>
                        <div className="coluna-emb">
                            <div className="flex-column">
                                <input
                                    type="checkbox"
                                    checked={values.comprovante || ""}
                                    onChange={(e) => {
                                        setValues((current) => ({
                                            ...current,
                                            comprovante: e.target.checked,
                                        }));
                                    }}
                                />
                                <p className="input-label-emb" htmlFor="descricao">
                                    Comprovante
                                </p>
                            </div>
                        </div>
                        <div className="coluna-emb">
                            <div className="flex-column">
                                <input
                                    type="checkbox"
                                    checked={values.checkInFeito || ""}
                                    onChange={(e) => {
                                        setValues((current) => ({
                                            ...current,
                                            checkInFeito: e.target.checked,
                                        }));
                                    }}
                                />
                                <p className="input-label-emb" htmlFor="descricao">
                                    Check-in
                                </p>
                            </div>
                        </div>
                        <div className="coluna-emb">
                            <div className="flex-column">
                                <input
                                    type="checkbox"
                                    checked={values.cancelado || ""}
                                    onChange={(e) => {
                                        setVerificaMotivo(!e.target.checked);
                                        setValues((current) => ({
                                            ...current,
                                            cancelado: e.target.checked,
                                        }));
                                        if (!e.target.checked) {
                                            handleClearMotivo();
                                        }
                                    }}
                                />
                                <p className="input-label-emb" htmlFor="descricao">
                                    Cancelado
                                </p>
                            </div>
                        </div>
                        <motion.div
                            initial={{ opacity: 0, height: 0 }}
                            animate={
                                values.cancelado
                                    ? { opacity: 1, height: "auto" }
                                    : { opacity: 0, height: 0 }
                            }
                            transition={{ duration: 0.3 }}
                        >
                            <div className="coluna-emb">
                                <div>
                                    <p className="input-label-emb" htmlFor="descricao">
                                        Motivo:
                                    </p>
                                    <SelectEmbarqueV2
                                        classeCss={202}
                                        onChange={(e) => {
                                            setValuesSelect((current) => ({
                                                ...current,
                                                motivo: e,
                                            }));
                                            setValues((current) => ({
                                                ...current,
                                                motivo: e.value,
                                            }));
                                            setValues((current) => ({
                                                ...current,
                                                motivoId: e.id,
                                            }));
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setDisable(true);
                                            setOpenCadastroMotivo(true);
                                        }}
                                        onInfoIconClick={setIdAtual}
                                        clearSelection={handleClearMotivo}
                                        pequeno={true}
                                        id="idMotivo"
                                        disabled={verificaMotivo}
                                        value={valuesSelect.motivo}
                                        titulo="Motivo"
                                        dadosSelect={motivo}
                                        referenciaId="motivo"
                                        referenciaItem="motivo"
                                        erro={values.cancelado && !values.motivo}
                                    />
                                </div>
                                <NewIcon
                                    onClick={() => {
                                        setOpenCadastroMotivo(true);
                                        setIdAtual(null);
                                        setDisable(false);
                                    }}
                                />
                            </div>
                        </motion.div>
                    </div>
                </div>
                <Separator size="xl" />
                <Divider direction="horizontal"/>
                <Separator size="xl" />
                <div className="coluna-3-emb" style={{ marginBottom: "10px" }}>
                    <div className="coluna-botoes-emb">
                        <div className="coluna-botoes-cadastrar">
                            {props.dados ? (
                                <CustomButtonV2
                                    classCss="custom-button-cadastrar"
                                    classText="button-texto-cadastrar"
                                    icone="iconeSave"
                                    titulo="Salvar"
                                    cor="#0946B8"
                                    disabled={loadingCadastro}
                                    valor={values}
                                    onClick={() => {
                                        if (contextoEmbarque === "templateEmbarque") {
                                            editarTemplate();
                                        } else {
                                            editar();
                                        }
                                    }}
                                />
                            ) : (
                                <CustomButtonV2
                                    classCss="custom-button-cadastrar"
                                    classText="button-texto-cadastrar"
                                    icone="iconeSave"
                                    titulo="Salvar"
                                    disabled={loadingCadastro}
                                    cor="#0946B8"
                                    valor={values}
                                    onClick={() => {
                                        if (contextoEmbarque === "templateEmbarque") {
                                            cadastrarTemplate();
                                        } else {
                                            cadastrar();
                                            if (
                                                validator.validatorEmpresa === "true" &&
                                                validator.validatorFilial === "true" &&
                                                validator.validatorPedido === "true" &&
                                                validator.validatorPrevisaoEmbarque === "true" &&
                                                validator.validatorPrevisaoEntrega === "true" &&
                                                validator.validatorStatus === "true" &&
                                                validator.validatorPlacaCavalo === "true" &&
                                                validator.validatorPlacaCarreta === "true" &&
                                                validator.validatorPlacaCarreta2 === "true" &&
                                                validator.validatorProprietario === "true" &&
                                                validator.validatorMotorista === "true" &&
                                                validator.validatorIcms === "true" &&
                                                validator.validatorFreteFiscal === "true" &&
                                                validator.validatorMeioPagamento === "true" &&
                                                validator.validatorEmbarcador === "true" &&
                                                validator.validatorDestinatario === "true" &&
                                                validator.validatorMercadoria === "true"
                                            ) {
                                                setValues({});
                                                setValuesSelect({});
                                            }
                                        }
                                    }}
                                />
                            )}
                            <CustomButtonV2
                                classCss="custom-button-cancelar"
                                classText="button-texto-cancelar"
                                titulo="Cancelar"
                                cor="#0946B8"
                                valor={values}
                                onClick={handleClickCancelar}
                            />
                        </div>
                        {!!props.dados && (
                            <CustomButtonV2
                                classCss="custom-button-verde"
                                classText="button-texto-cadastrar"
                                icone="iconeCheck"
                                titulo="Gerar link de finalização"
                                onClick={copyLinkFinalizarViagem}
                            />
                        )}
                    </div>
                </div>
                <Separator size="xl" />
                {!!imagesFinalizacaoViagem.length && (
                    <>
                        <CadastroViagemSectionTitle title="Imagens da finalização de viagem:" />
                        <motion.div layout className="coluna-1-emb">
                            <div className="multi-image-carousel-container">
                                <MultiImageCarousel
                                    images={imagesFinalizacaoViagem}
                                    chunkSize={5}
                                    onSelectImage={(index) => {
                                        setIsOpenModalImage(true);
                                        setSelectedImage(imagesFinalizacaoViagem[index].url);
                                    }}
                                    onDeleteImage={handleDeleteImage}
                                />
                            </div>
                        </motion.div>
                    </>
                )}
                <Separator size="xl" />
            </div>

        </>
    )
}

export default memo(FormEmbarqueBottom)